import React, { useState } from 'react';
import { EnvelopeIcon, ClipboardDocumentIcon } from '@heroicons/react/24/outline';

const ContactUs = () => {
  const [copied, setCopied] = useState(false);
  const [mailOpened, setMailOpened] = useState(false);
  const email = 'operation@life2sparks.com';

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // Fallback for older browsers
      alert(`Please copy this email address: ${email}`);
    }
  };

  const handleMailTo = () => {
    const subject = 'Contact from Vendor Portal';
    const body = 'Hello,\n\nI would like to get in touch regarding the vendor portal.\n\nBest regards,';
    
    // Show feedback immediately
    setMailOpened(true);
    setTimeout(() => setMailOpened(false), 3000);
    
    // Navigate directly to Gmail with pre-filled email
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    try {
      window.open(gmailUrl, '_blank');
    } catch (error) {
      // Fallback: show alert with email details
      alert(`Please send an email to:\n\n${email}\n\nSubject: ${subject}\n\nBody:\n${body}`);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Contact Us</h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            We're here to help! Reach out to us for any questions or support.
          </p>
        </div>

        {/* Main Contact Section */}
        <div className="flex justify-center">
          <div className="bg-white rounded-lg shadow-lg p-8 max-w-2xl w-full">
            <div className="text-center">
              <div className="flex justify-center mb-6">
                <EnvelopeIcon className="h-16 w-16 text-primary-600" />
              </div>
              <h2 className="text-3xl font-bold mb-6 text-gray-900">Get in Touch</h2>
              <p className="text-gray-600 mb-8 text-lg">
                Contact us via email for any inquiries or support.
              </p>
              
              {/* Email Display */}
              <div className="bg-gray-50 rounded-lg p-6 mb-6">
                <p className="text-sm text-gray-600 mb-2">Email Address</p>
                <a 
                  href={`https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=Contact%20from%20Vendor%20Portal&body=Hello%2C%0A%0AI%20would%20like%20to%20get%20in%20touch%20regarding%20the%20vendor%20portal.%0A%0ABest%20regards%2C`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-2xl font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
                >
                  {email}
                </a>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button
                  onClick={handleCopyEmail}
                  className="bg-gray-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-700 transition-colors flex items-center justify-center"
                >
                  <ClipboardDocumentIcon className="h-5 w-5 mr-2" />
                  {copied ? 'Copied!' : 'Copy Email'}
                </button>
                
                <button
                  onClick={handleMailTo}
                  className="bg-primary-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-primary-700 transition-colors flex items-center justify-center"
                  type="button"
                >
                  <EnvelopeIcon className="h-5 w-5 mr-2" />
                  {mailOpened ? 'Opening...' : 'Open Mail'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
